import { Theme } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { MuiTheme } from "theme";

interface IStylesProps {
  backgroundColor: string;
  strokeColor: string;
}

export default makeStyles<Theme, IStylesProps>((theme: MuiTheme) => ({
  card: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    position: "relative",
    minHeight: 48,
    height: 48,
    width: 48,
    minWidth: 48,
    overflow: "visible",
    cursor: "pointer",
    boxShadow: "none",
    "& $loader": {
      zIndex: 1,
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      width: "100%",
      height: "100%"
    },
    color: ({ backgroundColor }) =>
      backgroundColor ? `#${backgroundColor}` : theme.palette.text.primary,
    backgroundColor: ({ backgroundColor }) =>
      backgroundColor ? `#${backgroundColor}` : theme.palette.common.white,
    border: "none"
  },
  cardHeader: {
    "& > div": {
      overflow: "hidden"
    },
    height: 14,
    fontSize: 10,
    marginBottom: "0",
    whiteSpace: "nowrap",
    textAlign: "center",
    backgroundColor: ({ strokeColor }) =>
      strokeColor ? `#${strokeColor}` : theme.palette.primary.main,
    color: ({ backgroundColor }) =>
      backgroundColor ? `#${backgroundColor}` : theme.palette.common.white
  },
  squared: {
    color: theme.palette.text.primary,
    borderRadius: 2,
    width: 20,
    height: 20,
    border: "1px solid"
  },
  cardContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  cardActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    height: 16,
    maxHeight: 16,
    bottom: 0,
    left: 0,
    right: 0,
    overflow: "hidden"
  },
  moreHorizIcon: {
    fontSize: 18,
    color: ({ strokeColor }) =>
      strokeColor ? `#${strokeColor}` : theme.palette.text.primary
  },
  commentIcon: {
    fontSize: 9,
    color: "black",
    opacity: 0.4,
    position: "absolute",
    right: 2,
    bottom: 1
  },
  day: {
    fontSize: 8,
    top: -10
  },
  date: {
    lineHeight: "normal",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
    fontSize: 14,
    paddingTop: 4,
    "&$squared": {
      paddingTop: 0,
      marginTop: 3
    },
    color: ({ strokeColor }) =>
      strokeColor ? `#${strokeColor}` : theme.palette.text.primary
  },
  hasComments: {
    backgroundColor: "#000000"
  },
  loader: {
    position: "absolute",
    zIndex: 1,
    top: -1,
    left: -1,
    width: "calc(100% + 2px)",
    height: "calc(100% + 2px)",
    background: "rgba(255, 255, 255, 0.85)",
    padding: 0
  },
  widePane: {
    width: 120,
    "& $cardHeader .MuiCardHeader-content": {
      textTransform: "capitalize",
      overflow: "hidden",
      textOverflow: "ellipsis",
      padding: "0 8px"
    },
    "& $date, & $date$squared": {
      width: "auto",
      textTransform: "uppercase",
      height: 18,
      padding: "0 4px"
    }
  }
}));
